// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_ldB","cls2":"RelatedPapers-cls2_ux1 RelatedPapers-cls1_ldB"};